import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {EnglishToPersian} from "numeral-convert";
import {toFarsiNumber} from "../../cudtom-hooks/en-to-persian";
import FileDownload from "js-file-download";

const config = {
    headers: {Authorization: `Token ${localStorage.getItem('token')}`}
}
export const getNomadHistory = createAsyncThunk("commonStates/getNomadHistory", async(nomadId) => {
    let historyArray = [];
    await axios.get(`https://demo.khedmatashayer-kj.ir/api/v1/nomad/tanker-request/1?=&nomad_id=${nomadId}`, config)
        .then(res => {
            res.data.forEach(item => {
                let deliverDate, deliverTime;
                if(item.nomad_confirmed_at){
                    deliverDate = new Date(item.nomad_confirmed_at).toLocaleDateString('fa-IR');
                    deliverTime = EnglishToPersian(item.nomad_confirmed_at.slice(11));
                }
                let registerDate = new Date(item.created_at).toLocaleDateString('fa-IR');
                historyArray = [...historyArray, [toFarsiNumber(item.cost), toFarsiNumber(item.water_volume), deliverTime ?? '-', deliverDate ?? '-',
                    item.driver?.name ?? '-', registerDate, toFarsiNumber(item.region), toFarsiNumber(item.tanker_request_id), item.water_type === 1 ? 'آب شرب' : 'آب دام']]
            })
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return historyArray
})

export const getCities = createAsyncThunk('commonStates/getCities', async() => {
    let allCities = []
    await axios.get('https://demo.khedmatashayer-kj.ir/api/v1/city?province_id=1', config)
        .then((res) => {
            allCities = res.data
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
    return allCities
})

export const getExcel= createAsyncThunk("commonStates/getExcel", async(data) => { //This is using for three parts
    axios.post('https://demo.khedmatashayer-kj.ir/api/v1/report/excel', data, {...config, responseType: 'blob'})
        .then(res => {
            FileDownload(res.data, 'report.xlsx')
        })
        .catch(() => {
            alert('خطا در برقراری ارتباط با سرور')
        })
})

const commonStates = createSlice({
    name: 'commonStates',
    initialState: {
        isPending: false,
        callApi: false,
        registerBtnType: '',
        passwordFormServerError: '',
        showForm: false,
        showEditForm: false,
        showHistory: false,
        historyArray: [],
        allCities: []
    },
    reducers: {
        updatePending: (state, action) => {
            state.isPending = action.payload
        },
        callApiAgain: (state, action) => {
            state.callApi = action.payload
        },
        changeRegisterBtnType: (state, action) => {
            state.registerBtnType = action.payload
        },
        setPasswordFormServerError: (state, action) => {
            state.passwordFormServerError = action.payload
        },
        showPopUp: (state, action) => {
            let type = action.payload.type;
            let value = action.payload.value;
            switch (type){
                case 'showForm':
                    state.showForm = value;
                    break;
                case 'showEditForm':
                    state.showEditForm = value;
                    break;
                case 'showHistory':
                    state.showHistory = value;
                    break;
                default:
                    throw Error('Not valid')
            }
        },
    },
    extraReducers(builder){
        builder
            .addCase(getNomadHistory.fulfilled, (state, action) => {
                state.historyArray = action.payload
            })
            .addCase(getCities.fulfilled, (state, action) => {
                state.allCities = action.payload
            })
    }
})

export const {updatePending, showPopUp, callApiAgain, changeRegisterBtnType, setPasswordFormServerError} = commonStates.actions
export const selectIsPending = state => state.commonStates.isPending
export const selectCallApi = state => state.commonStates.callApi
export const selectShowForm = state => state.commonStates.showForm
export const selectShowEditForm = state => state.commonStates.showEditForm
export const selectShowHistory = state => state.commonStates.showHistory
export const selectRegisterBtnType = state => state.commonStates.registerBtnType
export const selectNomadHistoryArray = state => state.commonStates.historyArray
export const selectPasswordFormServerError = state => state.commonStates.passwordFormServerError
export const selectAllCities = state => state.commonStates.allCities

export default commonStates.reducer